// src/features/dynamic/components/DynamicProfileView.tsx

import ScopeViewRendererCard from "./ScopeViewRendererCard";

export default function ScopeProfileView({ modules }: { modules: any }) {
  if (!modules) return null;

  // 1. Flatten the groups into a single list of renderable items
  // We want to render a Card for "score", a Card for "experience", etc.
  const sectionsToRender: any[] = [];

  // Handle One-To-Many (Lists)
  if (modules.ONE_TO_MANY) {
    Object.entries(modules.ONE_TO_MANY).forEach(
      ([key, items]: [string, any]) => {
        if (items && items.length > 0) {
          // Use the label from the first item as the Card Title (e.g. "Score")
          const rawTitle = items[0].label || key;
          const title = rawTitle.replace(/Varients/gi, "Variants");
          sectionsToRender.push({ title, data: items, type: "LIST" });
        }
      }
    );
  }

  // Handle One-To-One (Single Items)
  if (modules.ONE_TO_ONE) {
    Object.entries(modules.ONE_TO_ONE).forEach(([key, item]: [string, any]) => {
      if (item) {
        const rawTitle = item.label || key;
        const title = rawTitle.replace(/Varients/gi, "Variants");
        sectionsToRender.push({ title, data: [item], type: "SINGLE" });
      }
    });
  }

  return (
    <div className="flex flex-col gap-2">
      {sectionsToRender.map((section, index) => (
        <ScopeViewRendererCard
          key={index}
          title={section.title}
          items={section.data}
        />
      ))}
    </div>
  );
}
